import CustomerService from "@/services/CustomerService.js";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    user: {},
    verifyOtpToken: null,
    pin: null,
    otp: null,
    location: null,
    cities: null,
    provinces: null,
    surveyStatus: false,
    successMessage: "",
    otpInitialErrorMessage: "",
    specialDiscountList: [],
    ssoRevampUrl: "",
    socialSSOData: null,
    socialSSOLinkingResponse: null,
    socialCustomerLoading: false
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_OTP(state, payload) {
      state.otp = payload;
    },
    SET_VERIFY_OTP_TOKEN(state, verifyOtpToken) {
      state.verifyOtpToken = verifyOtpToken;
    },
    SET_PIN(state, pin) {
      state.pin = pin;
    },
    SET_LOCATION(state, location) {
      state.location = location;
      localStorage.setItem("location", location);
    },
    SET_CITIES(state, cities) {
      state.cities = cities;
    },
    SET_PROVINCES(state, provinces) {
      state.provinces = provinces;
    },
    SET_SURVEY_STATUS(state, status) {
      state.surveyStatus = status;
    },
    resetLocation(state) {
      state.location = null;
    },
    setSuccessMessage(state, payload) {
      state.successMessage = payload;
    },
    setOtpInitialErrorMessage(state, payload) {
      state.otpInitialErrorMessage = payload;
    },
    setSpecialDiscountList(state, value) {
      state.specialDiscountList = value;
    },
    setSSORedirectURL(state, value) {
      state.ssoRevampUrl = value;
    },
    setSocialSSOVerificationData(state, data) {
      state.socialSSOData = data;
    },
    setSocialSSOLinkingResponse(state, response) {
      state.socialSSOLinkingResponse = response;
    },
    setCustomerLoading(state, { key, value }) {
      state[key] = value;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async validateCustomerRegistration({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        await CustomerService.validateCustomerRegistration(request);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async sendOtp({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      commit("setSuccessMessage", null);
      commit("setOtpInitialErrorMessage", null);

      try {
        await CustomerService.sendOtp(request);
        commit("setSuccessMessage", "Successfully sent OTP.");
      } catch (errors) {
        if({}.propertyIsEnumerable.call(request, 'additionalParam')
          && {}.propertyIsEnumerable.call(request.additionalParam, 'isInitialSend')
          && request.additionalParam['isInitialSend']
        )
          commit("setOtpInitialErrorMessage", errors);
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async sendOtpViaEmail({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      commit("setSuccessMessage", null);
      commit("setOtpInitialErrorMessage", null);

      try {
        await CustomerService.sendOtpViaEmail(request);
        commit("setSuccessMessage", "Successfully sent OTP.");
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async resendOtp({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setOtpInitialErrorMessage", null);
      try {
        await CustomerService.sendOtp(request);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
      commit("SET_LOADING", false);
    },
    async verifyOtp({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setSuccessMessage", null);
      commit("setOtpInitialErrorMessage", null);

      try {
        let response = await CustomerService.verifyOtp(request);
        commit("SET_ERRORS", null);
        commit("SET_OTP", request.payload.pin);
        commit("SET_VERIFY_OTP_TOKEN", response.token);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async verifyOtpEmail({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setSuccessMessage", null);
      commit("setOtpInitialErrorMessage", null);

      try {
        let response = await CustomerService.verifyOtpEmail(request);
        commit("SET_ERRORS", null);
        commit("SET_OTP", request.payload.pin);
        commit("SET_VERIFY_OTP_TOKEN", response.token);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async setPin({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        if (request.payload.newPin !== request.payload.confirmPin) {
          commit("SET_ERRORS", {
            errors: {
              confirmPin: "The Confirm PIN must match your New PIN"
            }
          });
        } else {
          request.payload.pin = request.payload.confirmPin;
          delete request.payload.newPin;
          delete request.payload.confirmPin;
          await CustomerService.setPin(request);
          commit("SET_PIN", request.payload.pin);
        }
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    forgotPinMobile: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      
      try {
        commit("SET_PIN", request.payload.pin);
        await CustomerService.forgotPinMobile(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    updatePin: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      try {
        if (request.payload.newPin !== request.payload.confirmPin) {
          commit("SET_ERRORS", {
            errors: {
              confirmPin: "The Confirm PIN must match your New PIN"
            }
          });
        } else {
          request.payload.pin = request.payload.confirmPin;
          delete request.payload.newPin;
          delete request.payload.confirmPin;

          await CustomerService.updatePin(request);
        }
        commit("SET_LOADING", false);
      } catch (errors) {
        if (errors.errors.message == "New Pin must be different from Old Pin") {
          commit("SET_ERRORS", {
            errors: {
              pin: errors.errors.message
            }
          });
        } else if (
          errors.errors.message == "Sorry, you have entered an invalid Pin."
        ) {
          commit("SET_ERRORS", {
            errors: {
              oldPin: errors.errors.message
            }
          });
        } else {
          commit("SET_ERRORS", errors);
        }
        commit("SET_LOADING", false);
      }
    },
    getCustomerProfile: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      try {
        let response = await CustomerService.getCustomerProfile(request);

        commit("SET_USER", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    updateCustomerProfile: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      try {
        let response = await CustomerService.updateCustomerProfile(request);
        commit("SET_USER", response.customer);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    updateCustomerName: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      
      try {
        const { customer } = await CustomerService.updateCustomerName(request);
        commit("SET_USER", customer);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getCities({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_CITIES", []); // clear init
      try {
        let response = await CustomerService.getCities(request);
        commit("SET_CITIES", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getProvinces({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await CustomerService.getProvinces(request);
        commit("SET_PROVINCES", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getSurveyStatus({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await CustomerService.getSurveyStatus(request);
        commit("SET_SURVEY_STATUS", response.survey_taken);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async saveBillingInfo({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        await CustomerService.saveBillingInfo(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async deleteAccount({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        await CustomerService.deleteAccount(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async validateUserPin({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        await CustomerService.validateUserPin(request);
      } catch(errors) {
        if ('message' in errors.errors) {
          commit("SET_ERRORS", {
            pin: errors.errors.message
          });
        } else {
          commit("SET_ERRORS", errors.errors);
        }
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async validateNewMobileNumber({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        await CustomerService.validateNewMobileNumber(request);
      } catch (errors) {
        commit("SET_ERRORS", {
          message: errors.errors.mobile_number
        });
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async sendCustomerNewNumberOtp({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      
      try {
        await CustomerService.sendCustomerNewNumberOtp(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async updateCustomerMobileNumber({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        const response = await CustomerService.updateCustomerMobileNumber(request);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors.errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getSpecialDiscountList({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setSpecialDiscountList", []);
      
      try {
        const { list } = await CustomerService.getSpecialDiscountList(request);
        
        commit("setSpecialDiscountList", list);
      } catch (errors) {
        commit("SET_ERRORS", errors.errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async uploadSpecialDiscount({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      try {
        return await CustomerService.uploadSpecialDiscount(request);
      } catch ({ errors, status }) {
        if (errors.message) {
          commit("SET_ERRORS", { message: errors.message });
        } else commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async generateSSOToken({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      try {
        const { rush_estore_url } = await CustomerService.generateSSOToken(request);
        
        commit("setSSORedirectURL", rush_estore_url);
      } catch ({ errors, status }) {
        if (errors.message) {
          commit("SET_ERRORS", { message: errors.message });
        } else commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async verifyGoogleSSO({ commit }, request) {
      commit("setCustomerLoading", { key: 'socialCustomerLoading', value: true });
      commit("SET_ERRORS", null);
      commit("setSocialSSOVerificationData", null);
      
      try {
        const response = await CustomerService.verifyGoogleSSO(request);
        
        commit("setSocialSSOVerificationData", response);
      } catch ({ errors, status }) {
        if (errors.message) {
          commit("SET_ERRORS", { message: errors.message });
        } else commit("SET_ERRORS", errors);
      } finally {
        commit("setCustomerLoading", { key: 'socialCustomerLoading', value: false });
      }
    },
    async linkCustomerSocialSSO({ commit }, request) {
      commit("setCustomerLoading", { key: 'socialCustomerLoading', value: true });
      commit("SET_ERRORS", null);

      try {
        const response = await CustomerService.linkCustomerSocialSSO(request);
        commit("setSocialSSOLinkingResponse", response);
      } catch ({ errors: { message, data }, status }) {
        if (message) {
          commit("SET_ERRORS", { message });
        } else commit("SET_ERRORS", { ...data });
      }
    },
    async verifyFacebookSSO({ commit }, request) {
      commit("setCustomerLoading", { key: 'socialCustomerLoading', value: true });
      commit("SET_ERRORS", null);
      commit("setSocialSSOVerificationData", null);
      
      try {
        const response = await CustomerService.verifyFacebookSSO(request);
        
        commit("setSocialSSOVerificationData", response);
      } catch ({ errors, status }) {
        if (errors.message) {
          commit("SET_ERRORS", { message: errors.message });
        } else commit("SET_ERRORS", errors);
      } finally {
        commit("setCustomerLoading", { key: 'socialCustomerLoading', value: false });
      }
    }
  },
  getters: {
    getUser: state => {
      return state.user;
    },
    provinces: state => {
      return state.provinces;
    },
    cities: state => {
      return state.cities;
    },
    surveyStatus: state => {
      return state.surveyStatus !== null ? state.surveyStatus : false;
    },
    loading: state => state.loading,
    ssoRevampUrl: state => state.ssoRevampUrl
  }
};
